import { getElevation } from '@m1/geo-utils';
import classNames from 'classnames/bind';
import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import styles from './common.module.scss';

import actions from '@/actions';
import FieldRow from '@/components/ui/FieldRow';
import { FieldNumber } from '@/components/ui/kit/Field';
import { roundToDecimal } from '@/utils/Formatter';

const cx = classNames.bind(styles);

const Command = ({ index, data: command }) => {
  const dispatch = useDispatch();
  const domRefs = useRef({
    latitude: useRef(),
    longitude: useRef(),
    relAltitude: useRef(),
  }).current;

  useEffect(() => {
    domRefs.latitude.current.value = command.data.position.lat.toFixed(7);
    domRefs.longitude.current.value = command.data.position.lng.toFixed(7);
    domRefs.relAltitude.current.value = command.data.altitude.toFixed(1);
  }, [command.data]);

  const updatePosition = (position) => {
    getElevation(position).then((elevation) => {
      const waypoint = { position, elevation };
      dispatch(actions.mission.moveWaypoint(command.id, waypoint));
    });
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = Number(e.target.value);

    // Latitude 변경된 경우
    if (name === 'latitude') {
      const nextValue = roundToDecimal(value, 7);
      updatePosition({ lat: nextValue, lng: command.data.position.lng });
    }
    // Longitude 변경된 경우
    else if (name === 'longitude') {
      const nextValue = roundToDecimal(value, 7);
      updatePosition({ lat: command.data.position.lat, lng: nextValue });
    }
    // Relative Altitude 변경된 경우
    else if (name === 'relAltitude') {
      const nextValue = roundToDecimal(value);
      dispatch(actions.mission.updateCommand(index, 'altitude', nextValue));
    }
  };

  return (
    <div className={cx('container')}>
      <FieldRow label="Latitude">
        <FieldNumber ref={domRefs.latitude} name="latitude" min={-85} max={85} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Longitude">
        <FieldNumber ref={domRefs.longitude} name="longitude" min={-180} max={180} onBlur={handleBlur} />
      </FieldRow>
      <FieldRow label="Relative Altitude" unit="m">
        <FieldNumber ref={domRefs.relAltitude} name="relAltitude" onBlur={handleBlur} />
      </FieldRow>
    </div>
  );
};

export default Command;
